import { useContext } from 'react';
import ItemCategories from '../../../ui-components/Categories';
import { bookingState } from '../client-state/booking-state-context';
import { selecetedItemCategoryActionTypes } from '../../../redusers/selected-item-category-reducer';
import useBookingShop from '../server-data/use-booking-shop';

const ItemCategoriesWithData = () => {
  const { data: shop } = useBookingShop();
  const { state, dispatch } = useContext(bookingState);

  let itemCategories: string[] = ['All'];

  if (shop?.items) {
    for (const item of shop.items) {
      if (!item.archived && item.categoryNames.length) {
        for (const category of item.categoryNames) {
          if (!itemCategories.find((foundCategory) => foundCategory === category)) {
            itemCategories.push(category);
          }
        }
      }
    }
  }

  return (
    <ItemCategories
      categories={itemCategories}
      currentCategory={state.selectedItemCategory}
      onChange={(category) => {
        dispatch({
          type: selecetedItemCategoryActionTypes.SELECTED_ITEM_CATEGORY_UPDATE,
          payload: category,
        });
      }}
    />
  );
};

export default ItemCategoriesWithData;
